import { useState, useEffect } from 'react';

const useLoadIconImage = filePath => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [image, setImage] = useState(null);
  useEffect(() => {
    setLoading(true);
    setError(null);
    const fetchImage = async () => {
      try {
        // the "import() blob" should not be completely variable.
        // In order to work ok the files needs to be added on the final bundle, look "rollup.config.js > copy()"
        const response = await import(`../../../../assets/icons/${filePath}`);
        setImage(response.default);
      } catch (err) {
        setImage(null);
        setError(err);
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchImage();
  }, [filePath]);
  return {
    loading,
    error,
    image
  };
};
var useLoadIconImage$1 = useLoadIconImage;

export { useLoadIconImage$1 as default };
//# sourceMappingURL=useLoadIconImage.js.map
